(() => {
  const button = document.querySelector('[data-red-back-to-top]');
  if (!button || button.dataset.bound) return;
  button.dataset.bound = 'true';
  const wrapper = document.querySelector('.page-wrapper');
  const sticky = document.querySelector('.catalog-mobile-sticky-atc--red');
  const scrollHost = () => wrapper && wrapper.scrollHeight > wrapper.clientHeight + 8 && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : document.scrollingElement;
  let frame;
  const update = () => {
    frame = 0;
    button.hidden = (scrollHost()?.scrollTop || 0) < 600;
    const rect = sticky?.getBoundingClientRect();
    const visible = sticky && !sticky.hidden && getComputedStyle(sticky).display !== 'none' && rect.height > 0 && rect.top < innerHeight;
    button.style.setProperty('--cart-clearance', visible ? `${Math.max(0, innerHeight - rect.top)}px` : '0px');
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', schedule, { passive: true });
  wrapper?.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (sticky) {
    new MutationObserver(schedule).observe(sticky, { attributes: true, childList: true, subtree: true });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(sticky);
  }
  button.addEventListener('click', () => {
    const heading = document.querySelector('h1');
    if (heading) {
      const original = heading.getAttribute('tabindex');
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
      heading.addEventListener('blur', () => {
        if (original === null) heading.removeAttribute('tabindex');
        else heading.setAttribute('tabindex', original);
      }, { once: true });
    }
    scrollHost()?.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  update();
})();
